/** Owns open state for the public appearance FAB + dialog. */
import { useCallback, useState } from 'react';
import { AppearanceDrawer } from './AppearanceDrawer';
import { AppearanceFab } from './AppearanceFab';

export function AppearanceControl() {
  const [open, setOpen] = useState(false);
  const close = useCallback(() => setOpen(false), []);
  const toggle = useCallback(() => setOpen((value) => !value), []);

  return (
    <div className="appearance-control">
      <AppearanceFab open={open} onClick={toggle} />
      <AppearanceDrawer open={open} onClose={close} />
    </div>
  );
}
